<template>
  <b-container class="pt-2 pb-2">
    <b-row class="no-gutters">
      <b-col>
        <b-card title="Profile" style="min-width: 20rem;" class="mb-2">
          <b-card-text> </b-card-text>
          <b-form>
            <b-form-group id="input-group-alias" label-cols="2" label-size="sm" label-align="right" label="Alias:">
              <b-input-group label="Alias:">
                <b-form-input
                  v-model="form.alias"
                  id="input-alias"
                  required
                  placeholder="Enter alias"
                  disabled
                ></b-form-input>
                <b-input-group-append v-if="isAdmin">
                  <b-button @click="onClickAliasEdit">
                    <font-awesome-icon :icon="['fas', 'pencil-alt']" />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
              <b-form-text>Your alias which is displayed to other users.</b-form-text>
            </b-form-group>
            <b-form-group id="input-roles" label-cols="2" label-size="sm" label-align="right" label="Roles:">
              <b-form-input v-model="form.roles" id="input-roles" disabled></b-form-input>
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
      <b-col class="ml-2" cols="7">
        <b-alert v-if="isAdmin" show>ToDo: write code<br /><small>Note: Only admins see this.</small></b-alert>
        <b-card v-if="isAdmin" title="Card Title" no-body>
          <b-card-header header-tag="nav">
            <b-nav card-header tabs>
              <b-nav-item active>POIs</b-nav-item>
              <b-nav-item v-b-tooltip title="the following POIs are waiting to be validated">
                POIs <font-awesome-icon :icon="['fas', 'eye']" />
              </b-nav-item>
              <b-nav-item v-b-tooltip title="the following POIs have been rejected">
                Rejected <font-awesome-icon :icon="['far', 'times-circle']" />
              </b-nav-item>
            </b-nav>
          </b-card-header>
          <b-card-body class="p-2">
            <b-alert show>ToDo: display last 10 POIs of the user</b-alert>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { db } from '@/main';

export default {
  name: 'ProfileView',
  data() {
    return {
      errors: [],
      form: {
        alias: '',
        roles: '',
      },
      formShow: false,
      profile: null,
    };
  },
  computed: {
    ...mapGetters({ isAdmin: 'auth/isAdmin', user: 'auth/user' }),
  },
  methods: {
    onClickAliasEdit() {
      alert('ToDo: enable alias edit');
    },
  },
  mounted() {
    const profileRef = db
      .collection('profiles')
      .doc(this.user.data.uid)
      .get();

    profileRef
      .then(doc => {
        if (doc.exists) {
          this.profile = doc.data();
          this.form.alias = this.profile.alias;
          this.form.roles = this.profile?.roles ? this.profile.roles.toString() : 'user';
        } else {
          // no profile found
        }
      })
      .catch(error => {
        this.errors.push(error);
      });
  },
};
</script>

<style scoped></style>
